function SupertestProgress({ activeQuestion, results }) {
	return (
		<div>
		</div>
	);
}
export default SupertestProgress;
